import TruckIcon from "@redotech/redo-icons/truck-02.svg";
import { RedoShopifyDeliveryMethodType } from "@redotech/redo-model/fulfillments/fulfillment-delivery-method-type";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";
import { deliveryMethodText } from "../../common/delivery-method-badge";

export const DeliveryMethodFilter: ArrayStringTableFilter<string> = {
  type: AdvancedFilterType.ARRAY_TO_STRING,
  Icon: TruckIcon,
  operators: [
    ArrayStringFilterOperator.ANY_OF,
    ArrayStringFilterOperator.ALL_OF,
    ArrayStringFilterOperator.NONE_OF,
  ],
  data: {
    name: "deliveryMethod",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "delivery method",
  itemLabelPlural: "delivery methods",
  values: Object.values(RedoShopifyDeliveryMethodType),
  display: (item: string) => {
    return deliveryMethodText[item as RedoShopifyDeliveryMethodType];
  },
  displayName: "Delivery method",
};
